import { Plugins } from '@capacitor/core';

const { StatusBar } = Plugins;

// Invoked from App-View.vue
// Not currently using - because hiding statusbar altogether on Android
export default async function hideStatusBar() {
  try {
    await StatusBar.hide();
  } catch (error) {
    console.error('Error hiding StatusBar:', error);
  }
}

// For Android app, change status bar to same color as top background color
// Invoked from category watcher in App-View.vue
// export default async function changeStatusBarColor(category = 'journey') {
//   const colors = {
//     journey: '#b0dcf4',
//     deepening: '#d3c1fc',
//     lightening: '#fffcdc',
//   };
//   const color = colors[category] || '#b0dcf4';

//   try {
//     await StatusBar.setBackgroundColor({
//       color,
//     });
//   } catch (error) {
//     console.error('Error setting StatusBar color:', error);
//   }
// }
